// // Learned from https://codepen.io/geckotang/post/dialog-with-animation
  function openDialog(sectionId) {
    // Get the dialog related to this section
    let dialog = document.getElementById('dialog-' + sectionId);
  
    // If the dialog doesn't exist, there's nothing to do
    if (!dialog) {
      console.log('No dialog found for section', sectionId);
      return;
    }
  
    // This function will be called when the open button is clicked
    dialog.showModal();
  
    // This function will be called when the close button is clicked
    document.querySelector("#js-close-button-" + sectionId).onclick = function () {
      dialog.classList.add("is-hidden");
  
      dialog.addEventListener("webkitAnimationEnd", function () {
        dialog.classList.remove("is-hidden");
        dialog.close();
  
        // Remove this event listener so it doesn't get triggered again unintentionally
        dialog.removeEventListener("webkitAnimationEnd", arguments.callee, false);
      }, false);
    };
  }